var buildArrayByRange = function buildArrayByRange() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return start && end ? Array.from({
    length: end - start + 1
  }, function (_, k) {
    return k + start;
  }) : [];
};
export default buildArrayByRange;